import React from 'react';
import { Input, InputAdornment } from '@material-ui/core';
import MuiIconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import styled from 'styled-components/macro';

const SearchInput = styled(Input)`
  && {
    padding: 0.1em 0.8em;
    ${({ variant }) => {
      switch (variant) {
        case 'contained':
          return 'background: #f8f9fa; border-radius: 10px;';
        case 'outlined':
          return 'background: #fff; border: 1px solid #e0e0e0; border-radius: 6px;';
        case 'underlined':
        default:
          break;
      }
    }}
  }
`;

const IconButton = styled(MuiIconButton)`
  && {
    padding: 0;
  }
`;
const SearchView = props => {
  return (
    <SearchInput
      placeholder="Search..."
      value={props.searchValue}
      onChange={e => props.setSearchValue(e.target.value)}
      endAdornment={
        <InputAdornment position="end">
          {props.searchValue && !props.disableClear ? (
            <Tooltip arrow title="Clear">
              <IconButton size="small" onClick={() => props.setSearchValue('')}>
                <ClearIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <SearchIcon />
          )}
        </InputAdornment>
      }
      variant={props.variant}
      disableUnderline={props.variant !== 'underlined'}
      {...props}
    />
  );
};

export default SearchView;
